import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GeneralInterceptor } from './general-interceptor.service';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: GeneralInterceptor, multi: true }
];
